// extracted by mini-css-extract-plugin
export default {"readonlyEnotif":"Preferences_readonlyEnotif__QbJSf","enotifCheckbox":"Preferences_enotifCheckbox__4YMGo"};